export const JOB_DETAIL_DESCRIPTION_NAME = 'Description';
